import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostCreatePaymentSystem = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_PAYMENT
            });
            dispatch(Action.SetGetListPaymentSystem({
                search: ''
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreatePaymentSystem as SetPostCreatePaymentSystem
}